import {
  buildPortfolioSimulations,
  highlightOnOff,
  simulationsDataPrep
} from "@/_core/data/Optimizer";
import { apiService } from "@/_services";

// === OPTIMIZER: Simulate Strategies === //
export function simulateStrategies(_this, fieldName, fieldShowLoadingName) {
  _this[fieldShowLoadingName] = true;
  let hedges = [];
  _this.strategies.forEach(function(d) {
    hedges = hedges.concat(d.data);
  });
  if (hedges.length === 0) {
    return;
  }
  let params =
    _this.selectedAssetLink === 0
      ? {
          method: "POST",
          endpoint: "simulate_currencies",
          content_type: "application/json",
          query_params: {
            format: "json",
            spot: _this.spot,
            currency: _this.currencyNumber,
            hedges: JSON.stringify(hedges)
          }
        }
      : {
          method: "POST",
          endpoint: "simulate_commodities",
          content_type: "application/json",
          query_params: {
            format: "json",
            spot: _this.spot,
            commodity: _this.commodityNumber,
            hedges: JSON.stringify(hedges)
          }
        };
  return apiService
    .getAll(params)
    .then(data => {
      _this[fieldName] = data;
      _this.strategies.forEach(function(d) {
        d.simulated = true;
      });
      _this[fieldShowLoadingName] = false;
      let percentageById = {};
      _this.strategies.forEach(function(d) {
        percentageById[d.id] = d.percentage;
      });
      simulationsDataPrep(_this);
      buildPortfolioSimulations(_this, percentageById);
      highlightOnOff(_this, "highlightBorder");
    })
    .catch(function(error) {
      _this[fieldShowLoadingName] = false;
      console.log(error);
    });
}
